import { UsersActionsTypes } from "../types/Users.reducer.types";

export function createRequest(
  values,
  { setSubmitting, isAdmin = false },
  closePanel
) {
  return {
    type: UsersActionsTypes.CREATE_REQUEST,
    payload: { values, setSubmitting, closePanel, isAdmin }
  };
}

export function createSuccess(message) {
  return {
    type: UsersActionsTypes.CREATE_SUCCESS,
    payload: { message }
  };
}

export function createFailure(message) {
  return {
    type: UsersActionsTypes.CREATE_FAIL,
    payload: { message }
  };
}

export function editRequest(
  values,
  { setSubmitting, isAdmin = false },
  closePanel
) {
  return {
    type: UsersActionsTypes.EDIT_REQUEST,
    payload: { values, setSubmitting, closePanel, isAdmin }
  };
}

export function editSuccess(message) {
  return {
    type: UsersActionsTypes.EDIT_SUCCESS,
    payload: { message }
  };
}

export function editFailure(message) {
  return {
    type: UsersActionsTypes.EDIT_FAIL,
    payload: { message }
  };
}

export function listRequest(filter, { isAdmin = false }) {
  return {
    type: UsersActionsTypes.LIST_REQUEST,
    payload: { filter, isAdmin }
  };
}

export function listSuccess({ list }) {
  return {
    type: UsersActionsTypes.LIST_SUCCESS,
    payload: { list }
  };
}

export function listFailure() {
  return {
    type: UsersActionsTypes.LIST_FAIL
  };
}

export function dismissMessage() {
  return {
    type: UsersActionsTypes.DISMISS_MESSAGE
  };
}
